import React from "react";
import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";

const PARAGRAPHS = [
  'Molti imprenditori sono intrappolati nella loro stessa azienda. Bravi nel loro mestiere, ma sempre in prima linea a spegnere incendi — senza mai il tempo di guardare dove sta andando la nave.',
  "La differenza tra un'azienda che sopravvive e una che cresce non sta nel prodotto, né nel mercato. Sta nella capacità di chi la guida di alzare lo sguardo: avere numeri chiari, una struttura solida, una visione a 5 anni.",
  "Quando un imprenditore smette di rincorrere i problemi e inizia a costruire un sistema, succede qualcosa di preciso: l'azienda produce di più, lui lavora meglio, e torna ad avere tempo per sé.",
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="section-manifesto"
      className="relative py-32 md:py-40 lg:py-48 overflow-hidden bg-navy-dark"
    >
      {/* soft radial gold accent */}
      <div aria-hidden className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-gold/[0.05] blur-[160px]" />
      </div>

      {/* thin gold hairlines top and bottom */}
      <div aria-hidden className="absolute top-0 inset-x-0 hairline" />
      <div aria-hidden className="absolute bottom-0 inset-x-0 hairline" />

      <div className="relative max-w-[820px] mx-auto px-6 md:px-10">
        {/* small gold ornament */}
        <Reveal>
          <div className="flex justify-center mb-14 md:mb-16">
            <span className="inline-flex items-center gap-4 text-gold" aria-hidden>
              <span className="w-10 h-px bg-gold/70" />
              <span className="font-display italic text-lg leading-none">§</span>
              <span className="w-10 h-px bg-gold/70" />
            </span>
          </div>
        </Reveal>

        <div className="space-y-8 md:space-y-10 text-center">
          {PARAGRAPHS.map((text, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 1, delay: 0.1 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="font-sans-crisp text-lg md:text-xl lg:text-[1.35rem] text-ink/80 leading-[1.75] tracking-[0.005em]"
              data-testid={`manifesto-paragraph-${i + 1}`}
            >
              {text}
            </motion.p>
          ))}
        </div>

        {/* Highlight line */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.1, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="mt-16 md:mt-20 flex flex-col items-center"
          data-testid="manifesto-highlight"
        >
          <span className="w-16 h-px bg-gold mb-10" aria-hidden />
          <p className="font-display font-semibold italic text-gold text-center leading-[1.15] tracking-tight text-3xl md:text-4xl lg:text-5xl">
            Un'azienda più redditizia.
            <br />
            Una vita più libera.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
